import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Get the root element
const rootElement = document.getElementById('root');
const staticContent = document.getElementById('static-content');

// If we're on an /app route, hide the static content and mount the React app
if (window.location.pathname.startsWith('/app')) {
  if (staticContent) {
    staticContent.style.display = 'none';
  }
  
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );
    
    // Dispatch event to notify that React has loaded
    // This is needed to hide the loading spinner
    window.dispatchEvent(new Event('react-loaded'));
  }
} else {
  // If we're not on an /app route, show the static content and clear the root
  if (staticContent) {
    staticContent.style.display = 'block';
  }
  if (rootElement) {
    rootElement.innerHTML = '';
  }
} 